export const FLOOR_PLAN_PLACEHOLDER =
    "https://static.prod-images.emergentagent.com/jobs/f5730796-c5e1-4d47-9446-8297a3a26151/images/4183629c018e5cf172304f7ab01c1a083abc740b63480b15a284a7b69e4904ad.jpeg";

export const SITE_URL = "https://swastikrealty.in";

export const site = {
    // Canonical image mapping: each project uses only its own supplied project image.
    // No South Mumbai projects are included in the active project collection.
    name: "Swastik Realty",
    values: "Find | Trust | Grow",
    rera: "A031182501913",
    contact: {
        phoneDisplay: "+91 81690 62990",
        phone: "+918169062990",
        whatsapp: "918169062990",
        email: "swastikrealty0807@gmail.com",
        address: "Mumbai, Maharashtra, India",
    },
    logo: "/swastik-logo.png",
    logoOriginal: "/swastik-logo-original.jpeg",

    social: {
        instagram: "https://www.instagram.com/swastik_realty_luxury/",
        facebook: "https://www.facebook.com/SwastikRealtyluxury",
        linkedin: "https://www.linkedin.com/company/swastik-realty-mumbai/",
        youtube: "", // placeholder — add later without redesign
        google: "", // Google Business Profile — add later
    },

    hero: {
        image: "/hero-mumbai-coastline.png",
    },

    nav: [
        { label: "Projects", href: "#signature" },
        { label: "Why Us", href: "#why" },
        { label: "Locations", href: "#locations" },
        { label: "Property Files", href: "#files" },
    ],

    philosophy: [
        {
            word: "Find",
            title: "Exceptional Residences",
            body: "Discover exceptional residences carefully selected for your lifestyle and investment goals.",
        },
        {
            word: "Trust",
            title: "Transparent Guidance",
            body: "Receive transparent guidance from a RERA-registered luxury real estate advisor.",
        },
        {
            word: "Grow",
            title: "A Lasting Legacy",
            body: "Build long-term wealth and create a lasting legacy through smart property decisions.",
        },
    ],

    galleryPool: [
        "/veena/veena-gallery-residence-exterior.jpg",
        "/veena/veena-gallery-sky-pool.jpg",
        "/veena/veena-gallery-rooftop-pool.jpg",
        "/projects/sunbeam-heights-canonical.png",
        "/projects/adani-linkbay-real.jpg",
        "/projects/gurukrupa-sea-mansions-hero.jpg",
    ],

    projects: [
        {
            id: "dlf-westpark",
            name: "The Westpark",
            developer: "DLF",
            location: "The Westpark, Andheri West, Mumbai",
            tagline: "A new luxury address by DLF in Andheri West.",
            audienceLine: "For families and investors who want scale, brand credibility and a landmark Andheri West address.",
            startingPrice: "₹7 Cr*",
            priceRange: "3 & 4 BHK from ₹7 Cr*",
            configurations: "3 & 4 BHK",
            possession: "To be confirmed",
            maharera: "PR1181012500079",
            mapQuery: "The Westpark, Andheri West, Mumbai",
            image: "/projects/dlf-westpark-building-clean.jpg",
            heroImage: "/projects/dlf-westpark-building-clean.jpg",
            plans: [{"config": "3 BHK", "carpet": "On Request", "price": "From ₹7 Cr*"}, {"config": "4 BHK", "carpet": "On Request", "price": "From ₹7 Cr*"}],
            overview: ["DLF Andheri West is presented in the supplied Swastik Realty project creative as a new luxury launch with 3 & 4 BHK residences.", "The project creative highlights 8 towers, 40 storeys, a 17-acre land parcel, a grand clubhouse, 30+ ultra-luxurious amenities and Infiniti Mall approximately 300 metres away."],
            highlights: ["8 towers", "40 storeys", "17-acre total land parcel", "Grand clubhouse", "30+ ultra-luxurious amenities", "Infiniti Mall — 300 m"],
            locationAdvantages: [{"label": "Andheri West", "time": "Project location"}, {"label": "Infiniti Mall", "time": "300 m (as per supplied creative)"}]
        },
        {
            id: "kalpataru-vian",
            name: "Kalpataru VIAN",
            developer: "Kalpataru",
            location: "Lokhandwala Complex, Andheri West, Mumbai",
            tagline: "Stillness with a side of stardust.",
            audienceLine: "For discerning buyers who value privacy, decks, greenery and a quieter Lokhandwala lifestyle.",
            startingPrice: "On Request",
            priceRange: "3, 4 & 4.5-bed residences",
            configurations: "3, 4 & 4.5-bed residences",
            possession: "To be confirmed",
            maharera: "PR1180002600863",
            mapQuery: "Lokhandwala Complex, Andheri West, Mumbai",
            image: "/projects/kalpataru-vian-1.jpg",
            heroImage: "/projects/kalpataru-vian-1.jpg",
            overview: ["Kalpataru VIAN is positioned as a landmark luxury address in Lokhandwala, where mangrove views and a private corner-plot setting create a quieter residential experience.", "The supplied project material describes 3, 4 and 4.5-bed residences, bespoke dual formats, grand decks with panoramic mangrove views and 30+ lifestyle amenities."],
            highlights: ["Located on Lokhandwala's back road on a private corner plot", "Approx. 4-acre meticulously planned enclave", "Grand decks offering panoramic mangrove views", "30+ curated lifestyle amenities", "3, 4 & 4.5-bed residences, including bespoke formats", "Connected to the city's key conveniences"],
            plans: [{"config": "3 Bed", "carpet": "On Request", "price": "On Request"}, {"config": "4 Bed", "carpet": "On Request", "price": "On Request"}, {"config": "4.5 Bed", "carpet": "On Request", "price": "On Request"}],
            gallery: ["/projects/kalpataru-vian-1.jpg", "/projects/kalpataru-vian-2.jpg", "/projects/kalpataru-vian-3.jpg", "/projects/kalpataru-vian-4.jpg"],
            amenities: ["30+ lifestyle amenities", "Grand decks", "Panoramic mangrove views", "Private corner-plot setting", "Curated lifestyle spaces"],
            locationAdvantages: [{"label": "Lokhandwala Complex", "time": "Project location"}, {"label": "Andheri West", "time": "Prime western-suburbs address"}, {"label": "Mangrove views", "time": "Panoramic outlook"}]
        },
        {
            id: "veena-monogram",
            name: "The Monogram Collection",
            developer: "Veena Developers",
            location: "Andheri West, Mumbai",
            tagline: "Where status meets space.",
            audienceLine: "For buyers upgrading to larger luxury residences with presence, privacy and premium Andheri West connectivity.",
            startingPrice: "₹5.75 Cr+",
            priceRange: "3.5 BHK from ₹5.75 Cr+ · 4 BHK from ₹6.47 Cr+",
            configurations: "3.5 & 4 BHK",
            possession: "To be confirmed",
            maharera: "PM1180002502479",
            mapQuery: "Andheri West, Mumbai",
            image: "/veena/veena-hero.jpg",
            heroImage: "/veena/veena-hero.jpg",
            overview: [
                "The Monogram Collection by Veena Developers is a premium residential address in Andheri West, Mumbai, created for buyers seeking larger luxury homes in a well-connected western-suburbs location.",
                "The new tower rises to G+36 storeys and features a 10.5 ft ceiling height, with spacious 3.5 and 4 BHK residences. EOI is open for the collection."
            ],
            highlights: [
                "G+36 storey luxury residential tower",
                "10.5 ft ceiling height",
                "3.5 BHK residences of 1400+ sq.ft.",
                "4 BHK residences across 1470, 1550, 1700 & 1800 sq.ft. options",
                "EOI open",
                "Prime Andheri West location"
            ],
            plans: [
                { config: "3.5 BHK", carpet: "1400+ sq.ft.", price: "₹5.75 Cr+" },
                { config: "4 BHK", carpet: "1470 sq.ft.", price: "₹6.47 Cr+" },
                { config: "4 BHK", carpet: "1550 sq.ft.", price: "On Request" },
                { config: "4 BHK", carpet: "1700 sq.ft.", price: "On Request" },
                { config: "4 BHK", carpet: "1800 sq.ft.", price: "On Request" }
            ],
            gallery: [
                "/veena/veena-hero.jpg",
                "/veena/veena-gallery-rooftop-pool.jpg",
                "/veena/veena-gallery-sky-pool.jpg",
                "/veena/veena-gallery-tower-view.jpg",
                "/veena/veena-gallery-residence-exterior.jpg",
                "/veena/veena-gallery-retail-podium.jpg",
                "/veena/veena-gallery-amenities.jpg"
            ]
        },
        {
            id: "adani-linkbay",
            name: "Adani Linkbay",
            developer: "Adani Realty",
            location: "New Link Road, Andheri West, Mumbai",
            tagline: "A landmark Adani Realty address where city living meets elevated views.",
            startingPrice: "On Request",
            priceRange: "2, 3 & 4 BHK · Pricing on request",
            configurations: "2, 3 & 4 BHK · Select larger homes",
            possession: "Oct 2028 (Phase I)",
            maharera: "P51800047539",
            mapQuery: "Linkbay Residences, New Link Road, Andheri West, Mumbai 400053",
            image: "/projects/adani-linkbay-real.jpg",
            heroImage: "/projects/adani-linkbay-real.jpg",
            audienceLine: "For buyers who want a landmark Andheri West address, skyline views and the Adani Realty legacy.",
            overview: [
                "Linkbay Residences by Adani Realty is located off Fun Republic, on New Link Road in Andheri West, Mumbai. The project is under construction and offers 2, 3 and 4 BHK residences.",
                "The main Phase I is targeted for possession around October 2028. A separate Phase II Wing B is registered under a separate RERA with a June 2030 completion target; buyers should verify the exact wing and inventory before booking."
            ],
            highlights: [
                "New Link Road, Andheri West",
                "2, 3 & 4 BHK residences",
                "Approx. 777–1,307 sq.ft. 2 BHK carpet range",
                "Approx. 1,153–1,522 sq.ft. 3 BHK carpet range",
                "Approx. 1,453–1,837 sq.ft. 4 BHK carpet range",
                "Limited larger configurations may be available",
                "50+ lifestyle amenities",
                "2.5-acre project land parcel",
                "Possession target: Oct 2028 for Phase I"
            ],
            plans: [
                { config: "2 BHK", carpet: "Approx. 777–1,307 sq.ft.", price: "On Request" },
                { config: "3 BHK", carpet: "Approx. 1,153–1,522 sq.ft.", price: "On Request" },
                { config: "4 BHK", carpet: "Approx. 1,453–1,837 sq.ft.", price: "On Request" },
                { config: "6 BHK", carpet: "Limited select inventory", price: "On Request" }
            ],
            locationAdvantages: [
                { label: "New Link Road", time: "Project address" },
                { label: "Andheri West Metro", time: "Approx. 5 min (as sourced)" },
                { label: "Andheri Railway Station", time: "Approx. 10 min (as sourced)" },
                { label: "Versova Beach", time: "Approx. 9 min (as sourced)" },
                { label: "Infiniti Mall / Fun Republic", time: "Close to project" }
            ]
        },
        {
            id: "sunbeam-heights",
            name: "Sunbeam Heights",
            developer: "Sunbeam Hightech Developers Pvt. Ltd.",
            location: "Andheri Link Road, Andheri West, Mumbai",
            tagline: "For the ones who own the horizon.",
            audienceLine: "For buyers seeking premium balcony living, strong connectivity and a near-term possession opportunity in Andheri West.",
            startingPrice: "₹2.53 Cr + Taxes",
            priceRange: "2 BHK ₹2.53–₹2.59 Cr + Taxes · 3 BHK ₹3.60 Cr + Taxes",
            configurations: "2 & 3 BHK Premium Balcony Residences",
            possession: "Next year (as supplied)",
            maharera: "51700079691",
            mapQuery: "Sunbeam Heights, New Link Road, Near Oshiwara Metro Station, Andheri West, Mumbai 400053",
            image: "/projects/sunbeam-heights-canonical.png",
            heroImage: "/projects/sunbeam-heights-canonical.png",
            overview: [
                "Sunbeam Heights is a premium residential development on Andheri Link Road, Andheri West. The latest project information supplied for the website states that construction is approximately 70% complete and possession is targeted for next year.",
                "The supplied inventory includes 2 BHK residences of 649 sq.ft. and 702 sq.ft. carpet area and a 3 BHK residence of 1,001 sq.ft. carpet area. Pricing supplied is ₹2.59 Cr + taxes for 649 sq.ft., ₹2.53 Cr + taxes for 702 sq.ft., and ₹3.60 Cr + taxes for 1,001 sq.ft."
            ],
            highlights: [
                "Construction approximately 70% complete (as supplied)",
                "2 BHK — 649 sq.ft. carpet — ₹2.59 Cr + taxes",
                "2 BHK — 702 sq.ft. carpet — ₹2.53 Cr + taxes",
                "3 BHK — 1,001 sq.ft. carpet — ₹3.60 Cr + taxes",
                "37-storey structure with signature facade",
                "20+ storey parking tower",
                "Flexible Jodi configurations",
                "Spacious sundeck in every residence",
                "15+ lifestyle amenities",
                "Possession information supplied as next year"
            ],
            plans: [
                { config: "2 BHK", carpet: "649 sq.ft.", price: "₹2.59 Cr + Taxes" },
                { config: "2 BHK", carpet: "702 sq.ft.", price: "₹2.53 Cr + Taxes" },
                { config: "3 BHK", carpet: "1,001 sq.ft.", price: "₹3.60 Cr + Taxes" }
            ],
            gallery: [
                "/projects/sunbeam-heights-canonical.png",
                "/projects/sunbeam-brochure-tower.jpg",
                "/projects/sunbeam-brochure-amenities.jpg",
                "/projects/sunbeam-connectivity.jpg",
                "/projects/sunbeam-location-map.jpg"
            ],
            amenities: [
                "Swimming Pool",
                "Fitness Centre",
                "Cricket Simulator",
                "Indoor Games",
                "Juice Bar",
                "Multipurpose Hall",
                "Kids' Play Area",
                "Yoga Room",
                "Reflexology Walkway",
                "Book Lounge",
                "Podium Garden"
            ],
            brochure: "/projects/sunbeam-heights-brochure.pdf",
            locationAdvantages: [
                { label: "Oshiwara Metro Station", time: "1 min" },
                { label: "Lower Oshiwara Metro Station", time: "2 min" },
                { label: "DN Nagar Metro Station", time: "6 min" },
                { label: "Versova Metro Station", time: "6 min" },
                { label: "Western Express Highway", time: "6 min" },
                { label: "Upcoming Coastal Road", time: "9 min" },
                { label: "JVLR", time: "9 min" },
                { label: "Andheri Railway Station", time: "10 min" },
                { label: "Chhatrapati Shivaji International Airport", time: "14 min" }
            ]
        },
        {
            id: "gurukrupa-sea-mansions",
            name: "Codename: Sea Mansions",
            developer: "Gurukrupa Realcon",
            location: "Juhu - Versova Link Road, Upper Juhu, Mumbai",
            tagline: "Where low-density living meets the sea.",
            audienceLine: "For buyers who want rare space, privacy and a sea-facing Upper Juhu lifestyle.",
            startingPrice: "₹55,000++",
            priceRange: "Band 1 ₹55,000++ · Band 2 ₹60,000++",
            configurations: "3, 4 & 5 BHK · Simplex Residences",
            possession: "June 2027",
            maharera: "To be updated",
            mapQuery: "Juhu - Versova Link Road, Upper Juhu, Mumbai",
            image: "/projects/gurukrupa-sea-mansions-canonical.png",
            heroImage: "/projects/gurukrupa-sea-mansions-canonical.png",
            overview: [
                "Codename: Sea Mansions by Gurukrupa Realcon is presented in the supplied project information as an ultra-luxury, low-density residence in Upper Juhu with sea views.",
                "The project is described as a G+13 storey tower with limited residences and six levels of basement parking. The supplied residences range from 3 BHK homes to large-format 4 & 5 BHK residences and 5,200 sq.ft. simplex residences."
            ],
            highlights: [
                "G+13 storey tower",
                "Limited residences",
                "6-level basement parking",
                "Sea-facing luxury positioning",
                "3 BHK — 1,284 to 1,380 sq.ft.",
                "4 & 5 BHK — 2,500 / 2,700 sq.ft.",
                "Simplex residences — 5,200 sq.ft.",
                "Possession: June 2027",
                "Upper Juhu location on Juhu - Versova Link Road"
            ],
            plans: [
                { config: "3 BHK", carpet: "1,284–1,380 sq.ft.", price: "Band pricing applies" },
                { config: "4 BHK", carpet: "2,500 sq.ft.", price: "Band pricing applies" },
                { config: "5 BHK", carpet: "2,700 sq.ft.", price: "Band pricing applies" },
                { config: "Simplex", carpet: "5,200 sq.ft.", price: "Band pricing applies" }
            ],
            amenities: [
                "Infinity Swimming Pool",
                "State-of-the-art Gym",
                "Terrace Garden",
                "Yoga Deck",
                "Landscaped Lawn",
                "Walking Track",
                "Gazebo",
                "Leisure Spaces"
            ],
            locationAdvantages: [
                { label: "Upper Juhu", time: "Project location" },
                { label: "Juhu - Versova Link Road", time: "Project address" },
                { label: "Sea Views", time: "As supplied" }
            ]
        },
    ],

    why: [
        { icon: "ShieldCheck", title: "RERA Registered", body: "Every engagement fully compliant and documented." },
        { icon: "BadgeCheck", title: "Verified Luxury Projects", body: "Only vetted, credential-checked residences make our list." },
        { icon: "Building2", title: "Trusted Developers", body: "Direct partnerships with Mumbai's finest builders." },
        { icon: "TrendingUp", title: "Investment Advisory", body: "Data-led guidance on value, yield and long-term growth." },
        { icon: "KeyRound", title: "Private Site Visits", body: "Discreet, chauffeured viewings at your convenience." },
        { icon: "HandshakeIcon", title: "End-to-End Assistance", body: "From shortlist to registration, we handle everything." },
    ],

    fileCategories: [
        "Market Reports",
        "Project Reviews",
        "Investment Guides",
        "Infrastructure Updates",
        "Luxury Buyer Psychology",
        "Area Guides",
        "Developer Insights",
    ],

    files: [
        { category: "Market Reports", title: "The Western Mumbai luxury premium, decoded for 2026.", excerpt: "How scarcity, connectivity, view corridors and branded residences are reshaping Western Mumbai's premium micro-markets.", read: "6 min read", image: "/veena/veena-gallery-residence-exterior.jpg", feature: true },
        { category: "Project Reviews", title: "Inside Western Mumbai's newest luxury addresses.", read: "4 min read", image: "/projects/dlf-westpark-building-clean.jpg" },
        { category: "Investment Guides", title: "Branded residences: Mumbai's new gold standard.", read: "7 min read", image: "/projects/kalpataru-vian-3.jpg" },
        { category: "Infrastructure Updates", title: "How the coastal road is redrawing value maps.", read: "5 min read", image: "/projects/sunbeam-location-map.jpg" },
        { category: "Luxury Buyer Psychology", title: "What discerning buyers really pay for.", read: "8 min read", image: "/projects/sunbeam-heights-canonical.png" },
    ],

    developers: [
        { name: "DLF", note: "A landmark new luxury address in Andheri West.", image: "/projects/dlf-westpark-building-clean.jpg" },
        { name: "Kalpataru", note: "Kalpataru VIAN at Lokhandwala, Andheri West.", image: "/projects/kalpataru-vian-3.jpg" },
        { name: "Veena Developers", note: "The Monogram Collection in Andheri West.", image: "/veena/veena-hero.jpg" },
        { name: "Adani Realty", note: "Linkbay Residences on New Link Road, Andheri West.", image: "/projects/adani-linkbay-real.jpg" },
        { name: "Sunbeam Hightech Developers", note: "Sunbeam Heights on Andheri Link Road.", image: "/projects/sunbeam-heights-canonical.png" },
        { name: "Gurukrupa Realcon", note: "Codename: Sea Mansions at Upper Juhu.", image: "/projects/gurukrupa-sea-mansions-canonical.png" },
    ],

    locations: [
        { name: "Andheri West", note: "Luxury residences across a prime western-suburbs address", image: "/projects/dlf-westpark-building-clean.jpg" },
        { name: "Lokhandwala", note: "Private, premium residential living", image: "/projects/kalpataru-vian-3.jpg" },
        { name: "Upper Juhu", note: "Low-density luxury with sea views", image: "/projects/gurukrupa-sea-mansions-canonical.png" },
        { name: "Andheri Link Road", note: "Connected premium residences", image: "/projects/sunbeam-heights-canonical.png" },
    ],

    budgets: ["₹2 Cr – ₹4 Cr", "₹4 Cr – ₹7 Cr", "₹7 Cr – ₹12 Cr", "₹12 Cr – ₹25 Cr", "₹25 Cr +"],
};
